import {RestResource} from '../rest'

import {ORGANIZATION_SERVER} from '../server'

const orgRole = new RestResource({server: ORGANIZATION_SERVER, resource: 'orgRole'});

export default orgRole;